import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms'
import { Employee } from '../../../api/models/employee.model'
import { TimesheetProject } from '../../../api/models/timesheet-project.model'
import { Utils } from '../utils/utils'

export const atleastOneChargeRequired = (formGroup: UntypedFormGroup): ValidationErrors | null => {
    const toChargeControl = formGroup.controls.toCharge
    const noChargeControl = formGroup.controls.noCharge
    if (toChargeControl.value || formGroup.controls.noCharge.value) {
        return null
    }

    return toChargeControl.value || noChargeControl.value ? null : { atleastOneChargeRequired: true }
}

export const maxTwelveHourCharge = (formGroup: UntypedFormGroup): ValidationErrors | null => {
    const toChargeControl = formGroup.controls.toCharge
    const noChargeControl = formGroup.controls.noCharge
    if (
        (toChargeControl.value || formGroup.controls.noCharge.value) &&
        !toChargeControl.hasError('chargeFormat') &&
        !noChargeControl.hasError('chargeFormat')
    ) {
        const totalSeconds =
            Utils.timeUnitStringToSeconds(toChargeControl.value) + Utils.timeUnitStringToSeconds(noChargeControl.value)

        return totalSeconds > 43200 ? { exceededTwelveHours: true } : null
    }

    return null
}

export const chargeFormatValidator =
    (): ValidatorFn =>
    (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value !== null && control.value !== undefined) {
            const regExp: RegExp = new RegExp(/^(\d*([.,,]{1}[\d*])?d)?(\s*)(\d*([.,,]{1}[\d*])?h)?(\s*)(\d*m)?$/)

            return !regExp.test(control.value) ? { chargeFormat: true } : null
        }

        return null
    }

export const legitimateEmployeeValidator =
    (allEmployees: Array<Employee>, setSelectedEmployee: Function, allowEmptySelection = false): ValidatorFn =>
    (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value !== null && control.value !== undefined && allEmployees) {
            const employee = allEmployees.find((e) => e.fullName === control.value)
            setSelectedEmployee(employee)

            return employee === undefined && !allowEmptySelection ? { employeeNotInList: true } : null
        }

        return null
    }

export const legitimateTimesheetProjectValidator = (
    allTimesheetProjects: Array<TimesheetProject>,
    getProjectName: Function,
    selectProject: Function,
    allowEmptySelection = false
): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value !== null && control.value !== undefined && allTimesheetProjects) {
            const timesheetProject = allTimesheetProjects.find((tp) => getProjectName(tp) === control.value)
            selectProject(timesheetProject)

            return timesheetProject === undefined && !allowEmptySelection ? { timesheetProjectNotInList: true } : null
        }

        return null
    }
}
